import { FC } from 'react';
import { Tooltip, Chip } from '@mui/material';
import { ApiKeyStatus } from '../types/api-key-types';
import { apiKeyStatusColorMap } from '../utils/api-key-utils';

const StatusChip: FC<React.PropsWithChildren<StatusChipProps>> = ({
  apiKeyStatus,
}) => {
  const tooltipTitle = '';

  const color = apiKeyStatusColorMap[apiKeyStatus] || 'default';

  return (
    <Tooltip arrow title={tooltipTitle}>
      <Chip
        label={apiKeyStatus}
        size='small'
        variant='outlined'
        color={color}
      />
    </Tooltip>
  );
};

export interface StatusChipProps {
  apiKeyStatus: ApiKeyStatus;
}

export default StatusChip;
